import { render } from "./LoaderPackage.vue?vue&type=template&id=232d8cb7"
const script = {}
script.render = render

export default script